import { Popover, Whisper } from 'rsuite';
import { FaExclamationTriangle } from 'react-icons/fa';
import React from 'react';

interface Props {
  title?: string;
  message: string;
  color?: string;
  children?: React.ReactNode;
}

export default function OrdersTableErrorPopover({
  title,
  message,
  color,
  children,
}: Props) {
  if (!message) {
    return null;
  }

  const speaker = (
    <Popover
      title={title}
      className="error-message-tooltip"
      arrow={false}
      style={{ maxWidth: '400px' }}
    >
      <div>
        <p>
          {message}
        </p>
        {children}
      </div>
    </Popover>
  );

  return (
    <Whisper
      trigger="click"
      placement="autoVerticalStart"
      preventOverflow
      speaker={speaker}
    >
      <span>
        <FaExclamationTriangle
          color={color}
          cursor="pointer"
        />
      </span>
    </Whisper>
  );
}

OrdersTableErrorPopover.defaultProps = {
  title: undefined,
  color: 'red',
  children: undefined,
};
